export default "__VITE_ASSET__DimG9ViW__"